module.exports = __webpack_public_path__ + "knight_blue.png?3f6f977d477dbd1ee2aed1d9b971313d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/art/knight_blue.png
// module id = 114
// module chunks = 0